import React from 'react';

export default function LoadingPage (props) {

    return (
        <div className="loading">Loading&#8230;</div>
    );
}